import styled, { css } from 'styled-components'

const designerCSS = css`
  #gameplay_stats {
    height: 35vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 15px;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .profile_avatar img {
    width: 30px;
    border-radius: 8px;
  }
  .menu_select {
    width: 18px;
    height: 18px;
    background: hsla(0, 0%, 0%, 0.2) url('http://yolo.tino.me/app_v3/resources/images/arrow_up.svg') center 4px / auto
      9px no-repeat;
    filter: invert(1);
    border-radius: 3px;
    cursor: pointer;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  .stats_tabs_wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    position: relative;
    z-index: 0;
    background: hsla(0, 0%, 100%, 0.05);
    background: hsla(212, 8%, 19%, 1);
    background: hsla(216, 12%, 14%, 1);
    padding: 10px 0 0 0;
    border-radius: 10px 10px 0 0;
    height: 100%;
  }
  #gameplay_stats:before {
    position: absolute;
    top: calc(50% + 7px);
    left: 0;
    background: linear-gradient(90deg, rgba(32, 37, 47, 0) 0%, rgba(32, 37, 47, 1) 100%);
    transform: translateY(-50%);
    content: '';
    height: 100%;
    width: 100%;
    z-index: -1;
    display: none;
  }
  .stats_tabs_wrapper .panels {
    width: 100%;
    overflow: hidden;
  }
  .stats_tabs_wrapper .panel {
    display: none;
    animation: fadein 0.8s;
    width: 100%;
    padding: 0;
    background: transparent;
    flex-flow: row;
  }
  .stats_tabs_wrapper .radio {
    display: none;
  }
  .stats_tabs_wrapper #stats_tabs_one:checked ~ .panels #one-panel {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .table_wrapper {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 5px 0 0 0;
    height: calc(35vh - 60px);
  }
  .table_wrapper .grid-body.busted_table {
    display: grid;
    grid-template-columns: 0.25fr 1fr 1fr 1fr 1fr;
    overflow: auto;
    width: 100%;
  }
  .table_wrapper .grid-header {
    display: contents;
  }
  .table_wrapper .grid-content {
    display: contents;
  }
  .table_wrapper .grid-body label {
    padding: 12px 6px 10px 6px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    font-size: 0.7rem;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    opacity: 1;
  }
  .table_wrapper .grid-header label {
    position: sticky;
    top: 0;
    font-size: 0.75rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: nowrap;
    border-top: 1px solid transparent;
    cursor: pointer;
    color: hsl(214, 5%, 30%);
    font-weight: 600;
    background: hsla(216, 12%, 14%, 1);
    z-index: 1;
    opacity: 1;
  }
  .table_wrapper .grid-header label span {
    color: hsl(214, 5%, 30%);
    font-size: 0.75rem;
  }
  .table_wrapper .grid-header label:hover {
    border-top: 1px solid hsla(221, 73%, 47%, 0.5);
    color: hsl(214, 5%, 80%);
    color: hsl(0, 0%, 100%);
  }
  .table_wrapper .grid-header label:hover span {
    color: hsl(0, 0%, 100%);
  }
  .table_wrapper .grid-header label.status {
    padding-left: 30px;
  }
  .table_wrapper .grid-content label.status {
    color: hsl(221, 73%, 47%);
    color: #fff;
    padding-left: 15px;
  }
  .table_wrapper .grid-content label.open {
    opacity: 1;
  }
  .table_wrapper .grid-content label.live.profit,
  .table_wrapper .grid-content label.closed.profit,
  .table_wrapper .grid-content label.open.profit {
    color: #fff;
    background: hsla(126, 100%, 38%, 0.1);
    border-bottom: 1px solid hsla(126, 100%, 38%, 0.1);
    border-bottom: 1px solid transparent;
  }
  .table_wrapper .grid-content label.busted.profit {
    color: #fff;
    background: hsla(340, 88%, 46%, 0.1);
    border-bottom: 1px solid hsla(340, 88%, 46%, 0.1);
    border-bottom: 1px solid transparent;
  }
  .table_wrapper .grid-content label.status img {
    width: 16px;
    height: 16px;
    margin: 0 5px 0 0;
  }
  .table_wrapper .grid-content label.pandl.profit,
  .table_wrapper .grid-content label.roi.profit {
    color: hsl(126, 100%, 38%);
  }
  .table_wrapper .grid-content label.up {
    color: hsl(126, 100%, 38%);
  }
  .table_wrapper .grid-content label.pandl.busted,
  .table_wrapper .grid-content label.roi.busted {
    color: hsl(340, 88%, 46%);
  }
  .table_wrapper .grid-content label.up.busted {
    color: hsl(340, 88%, 46%);
  }
  .table_wrapper .grid-header label .menu_select {
    width: 17px;
    height: 17px;
    background: hsla(0, 0%, 0%, 0.2) url('http://yolo.tino.me/app_v3/resources/images/arrow_up.svg') center 3px / auto
      10px no-repeat;
    filter: invert(1) brightness(0.4);
    margin: 0 0 0 6px;
    display: none;
  }
  .table_wrapper .grid-header label:hover .menu_select {
    filter: invert(1) brightness(1);
  }
  .table_wrapper .profile_avatar {
    margin: 0 5px 0 0;
    display: flex;
  }
  .table_wrapper .profile_avatar img {
    width: 20px;
    border-radius: 4px;
  }
  .table_wrapper .yourbids_table_row {
    display: contents;
  }
  .table_wrapper .yourbids_table_row:hover > label {
    background-color: hsla(0, 0%, 100%, 0.05);
    opacity: 1;
  }
  .table_wrapper .yourbids_table_row:hover > label.closed.profit,
  .table_wrapper .yourbids_table_row:hover > label.open.profit {
    background-color: hsla(126, 100%, 38%, 0.15);
  }
  .table_wrapper .yourbids_table_row:hover > label.busted.profit {
    background-color: hsla(340, 88%, 46%, 0.15);
  }
  .table_wrapper .yourbids_table_row:hover > label.status img {
    display: none;
  }
  .table_wrapper .grid-body .grid-content label.status:hover {
    cursor: pointer;
  }
  @media (max-width: 1600px) {
    #gameplay_stats {
      padding: 0 15px;
    }
  }
  @media (max-width: 1400px) {
    .table_wrapper .grid-body label {
      padding: 12px 4px 10px 4px;
    }
    .table_wrapper .grid-header label.status {
      padding-left: 10px;
    }
    .table_wrapper .grid-content label.status {
      padding-left: 10px;
    }
  }
  @media (max-width: 1250px) {
    #gameplay_stats {
      padding: 0 10px;
    }
    .stats_tabs_wrapper {
      padding: 15px 0 0 0;
    }
    .table_wrapper .grid-header label.status .menu_select {
      margin: 0;
    }
  }
  @media (max-width: 1100px) {
    .table_wrapper {
      height: calc(35vh - 67px);
    }
    .table_wrapper .grid-content label.status.open img {
      margin: 0;
    }
    .table_wrapper .grid-header label.status {
      padding-left: 10px;
    }
  }
  @media (max-width: 600px) {
    #gameplay_stats {
      padding: 0;
    }
    .table_wrapper .grid-header label .menu_select {
      display: none;
    }
  }
  @media (max-width: 430px) {
    #gameplay_stats {
      height: 50vh;
    }
    .stats_tabs_wrapper {
      border-radius: 0;
    }
    .table_wrapper {
      height: calc(50vh - 67px);
    }
    .table_wrapper .grid-content label.status {
      padding-left: 5px;
    }
    .table_wrapper .grid-body label {
      padding: 12px 2px 10px 2px;
      font-size: 0.7rem;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/dashboard.css */
  .radio {
    display: none;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/wallet.css */
  .radio {
    display: none;
  }
  /*! CSS Used keyframes */
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

const developerCSS = css``

export const BustedUsersCSS = styled.div`
  width: 100%;
  ${designerCSS}
  ${developerCSS}
`
